const SECRET_KEY = "YOUR_SECRET_KEY_123";

const getAESKey = async () => {
  const encoder = new TextEncoder();

  // Same as Django:
  // hashlib.sha256(SECRET_KEY.encode()).digest()
  const keyHash = await crypto.subtle.digest(
    "SHA-256",
    encoder.encode(SECRET_KEY),
  );

  return crypto.subtle.importKey(
    "raw",
    keyHash,
    {
      name: "AES-GCM",
    },
    false,
    ["encrypt"],
  );
};

const encryptParams = async (params) => {
  const encoder = new TextEncoder();

  // Same as Django:
  // json.dumps(params).encode()
  const plaintext = encoder.encode(JSON.stringify(params));

  // Same as Django:
  // os.urandom(12)
  const nonce = crypto.getRandomValues(new Uint8Array(12));

  const key = await getAESKey();

  // AES-GCM produces:
  // ciphertext + 16-byte authentication tag
  const encrypted = new Uint8Array(
    await crypto.subtle.encrypt(
      {
        name: "AES-GCM",
        iv: nonce,
        tagLength: 128,
      },
      key,
      plaintext,
    ),
  );

  const ciphertext = encrypted.slice(0, -16);
  const tag = encrypted.slice(-16);

  // Django expects:
  // nonce + tag + ciphertext
  const combined = new Uint8Array(
    nonce.length + tag.length + ciphertext.length,
  );

  combined.set(nonce, 0);
  combined.set(tag, nonce.length);
  combined.set(ciphertext, nonce.length + tag.length);

  let binary = "";

  combined.forEach((byte) => {
    binary += String.fromCharCode(byte);
  });

  // URL-safe Base64
  // IMPORTANT: DO NOT REMOVE "=" PADDING
  return btoa(binary).replace(/\+/g, "-").replace(/\//g, "_");
};

export const getEncryptedToken = async (encryptedTokenData) => {
  return encryptParams({
    EventID: String(encryptedTokenData?.eventID ?? "").trim(),
    User: String(encryptedTokenData?.username ?? "").trim(),
  });
};
